import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AuthService from "../services/authentication";
import usePatientList from "../data/patientList";
import { Table, Button, Modal, Input, Pagination, PageHeader } from "../ui";
import CreateOrderForm from "../sales_orders/CreateOrderForm";

function Patients() {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [submittedSearch, setSubmittedSearch] = useState("");
  let auth = AuthService.useAuth();
  const { patients, total_count, isLoading, isError } = usePatientList(
    page,
    submittedSearch,
    auth.authHeader()
  );
  const totalPages = Math.ceil(total_count / 20);
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearch = () => {
    setSubmittedSearch(search);
  };

  const formattedDate = (dateString) => {
    const date = new Date(dateString);
    if (!Number.isFinite(date.getTime())) {
      console.error("Invalid date:", dateString);
      return "Invalid date";
    }

    const year = date.getFullYear().toString().slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hour}:${minute}`;
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {isError.message}</div>;

  return (
    <div className="mx-auto w-full max-w-screen-xl px-4">
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateOrderForm />
        </Modal.Body>
      </Modal>
      <div className="flex w-1/2 mb-3">
        <Input
          type="text"
          placeholder="Search"
          value={search}
          onChange={handleSearchChange}
          className="me-2"
          onKeyPress={(event) => event.key === "Enter" && handleSearch()}
        />
        <Button variant="secondary" onClick={handleSearch}>
          Search
        </Button>
      </div>
      <PageHeader
        title="Patients"
        action={
          <Button variant="primary" onClick={() => setShowModal(true)}>
            Create new prescription
          </Button>
        }
      />
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Total Spend</th>
            <th>Last Payment</th>
          </tr>
        </thead>
        <tbody>
          {patients.map((patient) => (
            <tr
              key={patient.id}
              onClick={() => history.push(`/patient/${patient.id}`)}
            >
              <td>
                {patient.patient_first_name} {patient.patient_last_name}
              </td>
              <td>{patient.patient_email}</td>
              <td>${patient.total_spend.toFixed(2)}</td>
              <td>
                {patient.last_payment_date
                  ? formattedDate(patient.last_payment_date)
                  : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        page={page}
        totalPages={totalPages}
        totalCount={total_count}
        onPageChange={setPage}
      />
    </div>
  );
}

export default Patients;
